import { landingApiRequest } from '@/lib/landing-api'

export type MascotCoinPackage = { id: string; coins: number; amount_cents: number }
export type MascotCoinPurchase = {
  id: string
  campaign_id: number
  package_id: string
  coins: number
  amount_cents: number
  status: 'creating' | 'creation_uncertain' | 'pending' | 'expired' | 'paid'
  pix_key: string | null
  expires_at: string | null
  credited_at: string | null
}
export type MascotCoinCatalog = {
  packages: MascotCoinPackage[]
  purchase: MascotCoinPurchase | null
  sales_open: boolean
}

const base = (campaignId: number) => `/api/donor/campaigns/${campaignId}/mascot-coins`

export function fetchMascotCoinCatalog(campaignId: number, signal?: AbortSignal) {
  return landingApiRequest<MascotCoinCatalog>(base(campaignId), { signal })
}

export function createMascotCoinPurchase(
  campaignId: number,
  packageId: string,
  requestId: string
) {
  return landingApiRequest<MascotCoinPurchase>(base(campaignId), {
    method: 'POST',
    body: JSON.stringify({ package_id: packageId, request_id: requestId }),
  })
}

export function fetchMascotCoinPurchase(
  campaignId: number,
  id: string,
  signal?: AbortSignal
) {
  return landingApiRequest<MascotCoinPurchase>(
    `${base(campaignId)}/${encodeURIComponent(id)}`,
    { signal }
  )
}
